import { useCallback, useState } from 'react'

interface ConfirmOptions {
  title: string
  description: string
  confirmText?: string
  cancelText?: string
  variant?: 'destructive' | 'default'
}

export function useConfirm() {
  const [isOpen, setIsOpen] = useState(false)
  const [options, setOptions] = useState<ConfirmOptions>({
    title: '',
    description: '',
  })
  const [resolver, setResolver] = useState<(value: boolean) => void>(() => () => {})

  const confirm = useCallback((opts: ConfirmOptions): Promise<boolean> => {
    setOptions(opts)
    setIsOpen(true)
    return new Promise((resolve) => {
      setResolver(() => resolve)
    })
  }, [])

  const handleConfirm = useCallback(() => {
    setIsOpen(false)
    resolver(true)
  }, [resolver])

  const handleCancel = useCallback(() => {
    setIsOpen(false)
    resolver(false)
  }, [resolver])

  return {
    confirm,
    isOpen,
    options,
    handleConfirm,
    handleCancel,
  }
}
